AppTabs.createTab( {
name: 'locations',
icon: 'list-alt',
text: 'Locations',
create: function(init) {
	'use strict'

	init.setDataTableArgs( {

		tableId: 		'#data-table-locations',

		readTableName: 	'tblLocations',
		editTableName: 	'tblLocations',
		primaryKey: 	'LocationID',

		canSort:			true,
		paging:				false,

		actionData:			'datatable',
		actionAutofill: 	'datatable_autofill',
		actionCreate:		'datatable_create',
		actionEdit:			'datatable_edit',
		actionRemove:		'datatable_remove',

		editCallback:		function() {
			window.broadcastLocalStorageUpdateRequest( 'locationOptions' );
		},

		fields: [
			{
				label: 		'Location',
				columnName: 'Location',
				isEditable: true,
				order: 		'asc',
			},
			{
				label: 		'Location Code (for EDI)',
				columnName: 'LocationCode',
				isEditable: true,
			},
		],

	} );
}

} );
